<template>
  <PageWrapper>
    <template v-slot:content>
      <div class="upload-container">
        <el-button type="primary" size="small" class="el-icon-plus custom-btn" @click="handleAdd">新增汇率</el-button>
        <el-table border fit highlight-current-row class="customer-table" :data="list" v-loading="listLoading">
          <el-table-column label="币种（中文名称）" prop="currency_name"></el-table-column>
          <el-table-column label="币种（英文代码）" prop="currency"></el-table-column>
          <el-table-column label="汇率" prop="rate"></el-table-column>
          <el-table-column label="操作" width="200">
            <template v-slot="scope">
              <el-popconfirm
                iconColor="red"
                @confirm="handleDelete(scope, scope.$index)"
                title="确认删除此条数据吗？"
              >
                <el-button slot="reference" size="small" class="el-icon-delete" type="danger">删除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="pageSizeChange" @current-change="pageCurrentChange"
                       :current-page="selectPage.pageNum" :page-sizes="[20, 50, 100, 200]"
                       :page-size="selectPage.pageSize"
                       background
                       layout="total, sizes, prev, pager, next, jumper" :total="allNum"
                       style="margin-top: 14px;margin-bottom:14px"
        >
        </el-pagination>
        <Edit :dialog="dialog" :form-data="editFormData" @submit="handleSubmit"
              @close="handleClose" :type="type" :submitLoading="submitLoading"/>
      </div>
    </template>
  </PageWrapper>
</template>
<script>
import {computed, defineComponent, onMounted, reactive, ref} from '@vue/composition-api'
import request from '@/utils/request';
import PageWrapper from '@/components/PageWrapper/index.vue';
import waves from '@/directive/waves'
import Edit from './edit.vue'

export default defineComponent({
  name: 'inventoryQuery',
  components: {PageWrapper, Edit},
  directives: {waves},
  setup() {
    const searchFormRef = ref(null)
    const searchForm = reactive({})
    const showAll = ref(false)
    const selectPage = reactive({
      pageNum: 1,
      pageSize: 20,
    })
    const allNum = ref(1)
    const dialog = ref(false)
    const type = ref("")
    const editFormData = ref({})
    const list = ref([])
    const listLoading = ref(false)
    const submitLoading = ref(false)
    const word = computed(() => {
      if (!showAll.value) {
        return '展开'
      } else {
        return '收起'
      }
    })

    const getRate = () => {
      listLoading.value = false
      const url = `${process.env.VUE_APP_CONTROLLER_API}/exchange_rate.yy.php`
      request({
        url: url,
        method: 'get'
      }).then(res => {
        if (res.code === 200) {
          list.value = res.data
          allNum.value = res.total
        }
      })
    }

    onMounted(() => {
      getRate()
    })


    const handleAdd = () => {
      dialog.value = true;
      type.value = "add";
      editFormData.value = {}
    }
    const pageSizeChange = (e) => {
      selectPage.pageSize = e
      getRate()

    }
    const pageCurrentChange = (e) => {
      selectPage.pageNum = e
      getRate()
    }

    const handleSubmit = (form) => {
      let data;
      submitLoading.value = true
      if (type.value === 'add') {
        const url = `${process.env.VUE_APP_CONTROLLER_API}/exchange_rate_add.yy.php`
        data = request({
          url: url,
          method: 'post',
          data: form
        })
      }
      data.then(res => {
        if (res.code == 200) {
          submitLoading.value = false
          dialog.value = false
          getRate()
        }
      })
    }

    const handleClose = () => {
      dialog.value = false
      editFormData.value = {}
    }

    const handleDelete = (scope, index) => {
      request({
        url: 'exchange_rate_delete.yy',
        method: 'post',
        data: {id: scope.row.id}
      }).then(res => {
        if (res.code == 200) deleteRow(index)
      })
    }

    const deleteRow = (index) => list.value.splice(index, 1)


    return {
      list,
      searchForm,
      showAll,
      dialog,
      editFormData,
      type,
      allNum,
      selectPage,
      word,
      listLoading,
      searchFormRef,
      submitLoading,
      handleAdd,
      pageSizeChange,
      pageCurrentChange,
      handleSubmit,
      handleClose,
      handleDelete,
      deleteRow,
    };
  }
})
</script>
<style lang="scss" scoped>
.upload-container {
  padding: 20px;

  .customer-table {
    margin-top: 20px;

    .el-icon-delete {
      margin-left: 5px;
    }
  }
}
</style>
